import { ResolveFn } from '@angular/router';
import { InvoiceDocumentDetailModel } from '../../models/invoice/invoice-document-detail.model';
import { inject } from '@angular/core';
import { InvoiceDocumentHttpService } from '../../state/invoice-documents/invoice-document-http.service';
import { assert } from '../../assert/assert';
import { of } from 'rxjs';

export const invoiceDataResolver: ResolveFn<InvoiceDocumentDetailModel> = (route) => {
  const invoiceDocumentHttpService = inject(InvoiceDocumentHttpService);
  let id = route.queryParams[templateIdQueryParam];
  if (id) {
    assert(id >= 0);
    return invoiceDocumentHttpService.fetchSingleInvoiceDocument(
      // Load template (i.e. invoice) by id.
      +route.queryParams[templateIdQueryParam],
    );
  }

  id = +route.params.id;
  if (id) {
    assert(id >= 0);
    return invoiceDocumentHttpService.fetchSingleInvoiceDocument(id); // In edit mode, load existing invoice by id.
  }

  return of(null);
};

export const templateIdQueryParam = 'templateId';
